import { usePreviewPanelsContext } from '@atlassian/preview-panels-api';

export const usePreviewPanelsState = () => {
	const context = usePreviewPanelsContext();

	return {
		activePanel: context?.state?.panel,
		isPanelOpen: !!context?.state?.panel,
		width: context?.state?.panel ? context?.width : undefined,
	};
};
